import { PhoneCall } from "lucide-react";
import { CONTACT } from "../data";

export const FloatingCall = () => {
  return (
    <a
      data-testid="floating-call-button"
      href={CONTACT.phoneLink}
      className="md:hidden fixed bottom-4 left-4 right-4 z-[55] bg-[#DC2626] text-white border-2 border-[#09090B] shadow-[4px_4px_0_0_rgba(9,9,11,1)] font-anton uppercase tracking-wider text-lg py-3.5 flex items-center justify-center gap-2.5 active:translate-y-0.5 active:shadow-[2px_2px_0_0_rgba(9,9,11,1)] transition-all"
    >
      <PhoneCall size={20} />
      Zadzwoń
    </a>
  );
};
